module.exports = __webpack_public_path__ + "static/media/app_uploadfiles.e75212a8.svg";